import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-newVipIcon2",
  "use": "icon-newVipIcon2-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-newVipIcon2\"><title>1.Base基础/3.Icon图标/其他/server</title><path fill-rule=\"evenodd\" d=\"M7.5 15h5v-.625L10 13.75l-2.5.625zm10.625-4.375-.442.442-1.86-1.909.377 7.92a1 1 0 0 1-.999 1.047H4.804a1 1 0 0 1-.998-1.053l.418-7.914-1.907 1.909a2.4 2.4 0 0 1-.442-.324q-.144-.144 7.752-8.722c.184-.207.5-.22.703-.034l.031.03zM15 8.384v8.491H5V8.384l5-5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol